import React, { useMemo, useCallback, useRef, useState } from 'react'

import PropTypes from 'prop-types'

import InputAdornment from '@material-ui/core/InputAdornment'
import { Folder as FolderIcon } from '@material-ui/icons'

import colors from '@galo-monitor/styles/colors'
import TextField from '@galo-monitor/web-components/TextField'

import { HiddenInput, Wrapper } from './theme'

const InputFile = (props) => {
  const {
    accept,
    adornmentStyle,
    disabled,
    defaultValue,
    value,
    onChange,
    wrapperProps,
    InputComponent,
    ...rest
  } = props
  const fileInput = useRef(null)

  const initial = value || defaultValue
  const [selectedFile, setSelectedFile] = useState({
    name: initial ? String(initial) : ''
  })

  const handleChange = useCallback(() => {
    if (
      fileInput &&
      fileInput.current &&
      fileInput.current.files &&
      fileInput.current.files[0]
    ) {
      setSelectedFile(fileInput.current.files[0])

      if (onChange) {
        onChange(fileInput.current.files[0])
      }
    }
  }, [onChange])

  const HiddenFileInput = useMemo(() => () => (
    <HiddenInput
      ref={ fileInput }
      type="file"
      accept={ accept }
      onChange={ handleChange }
      disabled={ !!disabled }
    />
  ), [accept, disabled, handleChange])

  // TODO: Fix this when the time of uploading images come
  return (
    <Wrapper { ...wrapperProps }>
      {InputComponent ? (
        <InputComponent
          { ...rest }
          style={ disabled ? { pointerEvents: 'none' } : {} }
        >
          <HiddenFileInput />
        </InputComponent>
      ) : (
        <>
          <TextField
            { ...rest }
            value={ selectedFile.name }
            InputProps={ {
              endAdornment: (
                <InputAdornment style={ { ...adornmentStyle } } position="end">
                  <FolderIcon style={ { color: colors.grey } } />
                </InputAdornment>
              )
            } }
            style={ { pointerEvents: 'none' } }
          />
          <HiddenFileInput />
        </>
      )}
    </Wrapper>
  )
}

InputFile.propTypes = {
  accept: PropTypes.string,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  wrapperProps: PropTypes.object,
  adornmentStyle: PropTypes.object,
  InputComponent: PropTypes.any
}

InputFile.defaultProps = {
  accept: '',
  value: null,
  defaultValue: null,
  onChange: () => {},
  disabled: false,
  wrapperProps: {},
  adornmentStyle: {},
  InputComponent: null
}

export default InputFile
